import { Box } from "@mantine/core";
import { PatientForm, type PatientFormValues, PatientPayload } from "@ttn-shared/ui";
import { useUpdatePatientInformation } from "@app/services/common/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthentication } from "@app/store/useAuthtentication";

import {
  confirmNotification,
  successNotification,
  warningNotification
} from "@app/common/components/notifications";

const DISABLED_FIELDS: (keyof PatientFormValues)[] = [
  "documentTypeId",
  "documentNumber",
  "firstName",
  "middleName",
  "surname",
  "secondSurname",
  "birthDate"
];

export default function EditPatient() {
  const navigate = useNavigate();
  const { patientId = "" } = useParams();
  const idAccount = useAuthentication((store) => store.auth.dataBiowel.idAccount);
  const policyContent = useAuthentication((store) => store.auth.dataBiowel.dataPolicy);

  const { mutateAsync: updatePatient } = useUpdatePatientInformation(() => {});

  const handleSubmit = (payload: PatientPayload) => {
    const message = `Se editará al paciente: ${payload.firstName} ${payload.lastName}`;

    confirmNotification(message, "¿Está seguro?", () => {
      handleUpdatePatient(payload);
    });
  };

  const handleUpdatePatient = async (payload: PatientPayload) => {
    void (await updatePatient({ ...payload, id: Number(patientId), eaccount: idAccount }));

    successNotification(
      `Paciente: ${payload.firstName} ${payload.lastName} actualizado con éxito`,
      "Paciente actualizado correctamente"
    );

    navigate(-1);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      className="searchSection"
      p="md"
      style={{ overflow: "hidden", overflowY: "auto", height: "100%" }}
    >
      <PatientForm
        defaultMode="edit"
        disabledFields={DISABLED_FIELDS}
        policyContent={policyContent}
        patientId={Number(patientId)}
        onBack={handleBack}
        onSavePatient={handleSubmit}
        onSaveError={(error) => warningNotification(error)}
      />
    </Box>
  );
}
